var STATUS_VALID;
(function (STATUS_VALID) {
    STATUS_VALID["ACCEPTED"] = "ACCEPTED";
    STATUS_VALID["CONTINUE"] = "CONTINUE";
    STATUS_VALID["CREATED"] = "CREATED";
    STATUS_VALID["OK"] = "OK";
})(STATUS_VALID || (STATUS_VALID = {}));
var STATUS_FIVE_HUNDRED;
(function (STATUS_FIVE_HUNDRED) {
    STATUS_FIVE_HUNDRED["BAD_GATEWAY"] = "BAD_GATEWAY";
    STATUS_FIVE_HUNDRED["INTERNAL_SERVER_ERROR"] = "INTERNAL_SERVER_ERROR";
    STATUS_FIVE_HUNDRED["NOT_IMPLEMENTED"] = "NOT_IMPLEMENTED";
    STATUS_FIVE_HUNDRED["SERVICE_UNAVAILABLE"] = "SERVICE_UNAVAILABLE";
})(STATUS_FIVE_HUNDRED || (STATUS_FIVE_HUNDRED = {}));
var STATUS_FOUR_HUNDRED;
(function (STATUS_FOUR_HUNDRED) {
    STATUS_FOUR_HUNDRED["BAD_REQUEST"] = "BAD_REQUEST";
    STATUS_FOUR_HUNDRED["CONFLICT"] = "CONFLICT";
    STATUS_FOUR_HUNDRED["EXPECTATION_FAILED"] = "EXPECTATION_FAILED";
    STATUS_FOUR_HUNDRED["FAILED_DEPENDENCY"] = "FAILED_DEPENDENCY";
    STATUS_FOUR_HUNDRED["FORBIDDEN"] = "FORBIDDEN";
    STATUS_FOUR_HUNDRED["GONE"] = "GONE";
    STATUS_FOUR_HUNDRED["LENGTH_REQUIRED"] = "LENGTH_REQUIRED";
    STATUS_FOUR_HUNDRED["METHOD_NOT_ALLOWED"] = "METHOD_NOT_ALLOWED";
    STATUS_FOUR_HUNDRED["NOT_ACCEPTABLE"] = "NOT_ACCEPTABLE";
    STATUS_FOUR_HUNDRED["NOT_FOUND"] = "NOT_FOUND";
    STATUS_FOUR_HUNDRED["PAYLOAD_TOO_LARGE"] = "PAYLOAD_TOO_LARGE";
    STATUS_FOUR_HUNDRED["PRECONDITION_FAILED"] = "PRECONDITION_FAILED";
    STATUS_FOUR_HUNDRED["PROXY_AUTHENTICATION_REQUIRED"] = "PROXY_AUTHENTICATION_REQUIRED";
    STATUS_FOUR_HUNDRED["RANGE_NOT_SATISIFABLE"] = "RANGE_NOT_SATISIFABLE";
    STATUS_FOUR_HUNDRED["REQUEST_TIMEOUT"] = "REQUEST_TIMEOUT";
    STATUS_FOUR_HUNDRED["TOO_MANY_REQUESTS"] = "TOO_MANY_REQUESTS";
    STATUS_FOUR_HUNDRED["UNAUTHORIZED"] = "UNAUTHORIZED";
    STATUS_FOUR_HUNDRED["UNPROCESSABLE_ENTITY"] = "UNPROCESSABLE_ENTITY";
    STATUS_FOUR_HUNDRED["UNSUPPORTED_MEDIA_TYPE"] = "UNSUPPORTED_MEDIA_TYPE";
    STATUS_FOUR_HUNDRED["URI_TOO_LONG"] = "URI_TOO_LONG";
})(STATUS_FOUR_HUNDRED || (STATUS_FOUR_HUNDRED = {}));
const STATUS = {
    ...STATUS_VALID,
    ...STATUS_FIVE_HUNDRED,
    ...STATUS_FOUR_HUNDRED,
};
var TRANSPORT;
(function (TRANSPORT) {
    TRANSPORT["GRPC"] = "GRPC";
    TRANSPORT["REST"] = "REST";
})(TRANSPORT || (TRANSPORT = {}));
var HTTP_METHOD;
(function (HTTP_METHOD) {
    HTTP_METHOD["DELETE"] = "delete";
    HTTP_METHOD["GET"] = "get";
    HTTP_METHOD["PATCH"] = "patch";
    HTTP_METHOD["POST"] = "post";
    HTTP_METHOD["PUT"] = "put";
})(HTTP_METHOD || (HTTP_METHOD = {}));
var REST_PARAM_TYPE;
(function (REST_PARAM_TYPE) {
    REST_PARAM_TYPE["COOKIE"] = "cookie";
    REST_PARAM_TYPE["HEADER"] = "header";
    REST_PARAM_TYPE["PATH"] = "path";
    REST_PARAM_TYPE["QUERY"] = "query";
})(REST_PARAM_TYPE || (REST_PARAM_TYPE = {}));
var REST_BODY_TYPE;
(function (REST_BODY_TYPE) {
    REST_BODY_TYPE["FORM"] = "form";
    REST_BODY_TYPE["JSON"] = "json";
})(REST_BODY_TYPE || (REST_BODY_TYPE = {}));
const MAPPING = {
    100: 'CONTINUE',
    200: 'OK',
    201: 'CREATED',
    202: 'ACCEPTED',
    400: 'BAD_REQUEST',
    401: 'UNAUTHORIZED',
    403: 'FORBIDDEN',
    404: 'NOT_FOUND',
    405: 'METHOD_NOT_ALLOWED',
    406: 'NOT_ACCEPTABLE',
    407: 'PROXY_AUTHENTICATION_REQUIRED',
    408: 'REQUEST_TIMEOUT',
    409: 'CONFLICT',
    410: 'GONE',
    411: 'LENGTH_REQUIRED',
    412: 'PRECONDITION_FAILED',
    413: 'PAYLOAD_TOO_LARGE',
    414: 'URI_TOO_LONG',
    415: 'UNSUPPORTED_MEDIA_TYPE',
    416: 'RANGE_NOT_SATISIFABLE',
    417: 'EXPECTATION_FAILED',
    422: 'UNPROCESSABLE_ENTITY',
    424: 'FAILED_DEPENDENCY',
    429: 'TOO_MANY_REQUESTS',
    500: 'INTERNAL_SERVER_ERROR',
    501: 'NOT_IMPLEMENTED',
    502: 'BAD_GATEWAY',
    503: 'SERVICE_UNAVAILABLE',
};
export { HTTP_METHOD, MAPPING, REST_BODY_TYPE, REST_PARAM_TYPE, STATUS, STATUS_FIVE_HUNDRED, STATUS_FOUR_HUNDRED, TRANSPORT, };
//# sourceMappingURL=enums.js.map